// Translation strings for all supported languages
export const translations = {
  en: {
    // Meta
    pageTitle: 'PublicQ - Free Open Source Assessment & Exam Platform for Education & Training',
    
    // Hero section
    heroTitle: 'Modern Assessment Platform',
    heroSubtitle: 'Free & Open Source • Create, manage, and deploy educational assessments with ease',
    oneClickDemo: 'One Click Demo',
    learnMore: 'Learn More',
    viewOnGitHub: 'View on GitHub',
    
    // Features section
    everythingYouNeed: 'Everything You Need',
    comprehensiveSolution: 'A comprehensive solution for educational and professional assessments',
    
    easyAssessmentCreation: 'Easy Assessment Creation',
    easyAssessmentDesc: 'Build comprehensive assessments with multiple question types, file attachments, and customizable settings',
    
    versionControl: 'Version Control',
    versionControlDesc: 'Manage different versions of your assessments with full revision history and backward compatibility',
    
    smartUserManagement: 'Smart User Management',
    smartUserManagementDesc: 'Role-based access control with seven distinct roles from Exam Taker to Administrator',
    
    detailedAnalytics: 'Detailed Analytics',
    detailedAnalyticsDesc: 'Track performance with comprehensive reports, real-time analytics, and export capabilities',
    
    aiPoweredAssistance: 'AI-Powered Assistance',
    aiPoweredAssistanceDesc: 'Meet AI Monkey - our smarty pants pet sidekick! This mischievous genius helps you craft questions, generate content, and throw in clever suggestions. It can even analyze student performance and create individual improvement plans. It\'s like having a monkey with a PhD on your team! 🍌',
    
    realTimeExecution: 'Real-Time Execution',
    realTimeExecutionDesc: 'Live assessment taking with progress tracking, automatic scoring, and instant results',
    
    mobileFriendly: 'Mobile Friendly',
    mobileFriendlyDesc: 'Responsive design works seamlessly on desktop, tablet, and mobile devices',
    
    secureReliable: 'Secure & Reliable',
    secureReliableDesc: 'JWT authentication, role-based authorization, and comprehensive security features',
    
    communicationTools: 'Communication Tools',
    communicationToolsDesc: 'System-wide announcements, notifications, and customizable alerts for important events',
    
    flexibleConfiguration: 'Flexible Configuration',
    flexibleConfigurationDesc: 'Customize everything from password policies to assessment defaults through the admin panel',
    
    easyDeployment: 'Easy Deployment',
    easyDeploymentDesc: 'Single Docker command deployment with automatic data persistence and easy updates',
    
    apiIntegration: 'API Integration',
    apiIntegrationDesc: 'Comprehensive RESTful API with Swagger documentation for seamless integrations',
    
    // Use Cases section
    perfectFor: 'Perfect For',
    
    educationalInstitutions: 'Educational Institutions',
    educationalInstitutionsDesc: 'Schools, colleges, and universities creating exams and quizzes for students',
    
    corporateTraining: 'Corporate Training',
    corporateTrainingDesc: 'Companies conducting employee assessments, certifications, and skill evaluations',
    
    onlineLearning: 'Online Learning',
    onlineLearningDesc: 'E-learning platforms needing robust assessment and progress tracking features',
    
    certificationPrograms: 'Certification Programs',
    certificationProgramsDesc: 'Organizations offering professional certifications and credential verification',
    
    // Open Source section
    freeOpenSource: '100% Free & Open Source',
    freeOpenSourceDesc: 'PublicQ is completely free to use with no licensing costs. Available as an open-source project under the MIT license, you can deploy it on your own infrastructure, customize it to your needs, and contribute back to the community.',
    
    // CTA section
    needCustomFeatures: 'Need Custom Features or Support?',
    needCustomFeaturesDesc: 'While PublicQ is free and open source, we offer professional services for custom feature development, deployment assistance, integration support, and ongoing maintenance.',
    contactUs: 'Contact Us for Custom Services',
    customizeNote: 'We\'ll help you customize PublicQ to fit your exact needs',
    
    // Footer
    publicqDesc: 'Modern assessment platform for education and training',
    quickLinks: 'Quick Links',
    features: 'Features',
    documentation: 'Documentation',
    contact: 'Contact',
    forCustomFeatures: 'For custom features and professional support',
    iconsBy: 'Icons on this landing page provided by',
    copyright: 'PublicQ. Free & Open Source under MIT License.',
  },
  
  ru: {
    // Meta
    pageTitle: 'PublicQ - Бесплатная Платформа для Онлайн Экзаменов и Тестирования',
    
    // Hero section
    heroTitle: 'Современная Платформа Онлайн Экзаменов',
    heroSubtitle: 'Бесплатно и с Открытым Исходным Кодом • Создавайте, управляйте и развертывайте образовательную платформу с легкостью',
    oneClickDemo: 'Демо в Один Клик',
    learnMore: 'Узнать Больше',
    viewOnGitHub: 'Посмотреть на GitHub',
    
    // Features section
    everythingYouNeed: 'Все, Что Вам Нужно',
    comprehensiveSolution: 'Комплексное решение для образовательного и профессионального тестирования',
    
    easyAssessmentCreation: 'Простое Создание Тестов',
    easyAssessmentDesc: 'Создавайте комплексные тесты и экзамены с различными типами вопросов, вложениями файлов и настраиваемыми параметрами',
    
    versionControl: 'Контроль Версий',
    versionControlDesc: 'Управляйте различными версиями ваших тестов с полной историей изменений и обратной совместимостью',
    
    smartUserManagement: 'Интеллектуальное Управление Пользователями',
    smartUserManagementDesc: 'Ролевой контроль доступа с семью различными ролями от сдающего экзамен до администратора',
    
    detailedAnalytics: 'Подробная Аналитика',
    detailedAnalyticsDesc: 'Отслеживайте производительность с помощью комплексных отчетов, аналитики в реальном времени и возможностей экспорта',
    
    aiPoweredAssistance: 'Помощь на Основе ИИ',
    aiPoweredAssistanceDesc: 'Познакомьтесь с AI Мартышкой - нашим умным помощником! Этот озорной гений поможет вам создавать вопросы, генерировать контент и предлагать умные подсказки. Он даже может анализировать успеваемость студентов и создавать индивидуальные планы улучшения. Это как иметь обезьяну с докторской степенью в вашей команде! 🍌',
    
    realTimeExecution: 'Выполнение в Реальном Времени',
    realTimeExecutionDesc: 'Живое прохождение экзаменов с отслеживанием прогресса, автоматической проверкой и мгновенными результатами',
    
    mobileFriendly: 'Удобно для Мобильных Устройств',
    mobileFriendlyDesc: 'Адаптивный дизайн отлично работает на настольных компьютерах, планшетах и мобильных устройствах',
    
    secureReliable: 'Безопасность и Надежность',
    secureReliableDesc: 'JWT-аутентификация, ролевая авторизация и комплексные функции безопасности',
    
    communicationTools: 'Инструменты Коммуникации',
    communicationToolsDesc: 'Общесистемные объявления, уведомления и настраиваемые оповещения о важных событиях',
    
    flexibleConfiguration: 'Гибкая Настройка',
    flexibleConfigurationDesc: 'Настройте все, от политик паролей до параметров тестов по умолчанию через панель администратора',
    
    easyDeployment: 'Простое Развертывание',
    easyDeploymentDesc: 'Развертывание одной командой Docker с автоматическим сохранением данных и простыми обновлениями',
    
    apiIntegration: 'Интеграция API',
    apiIntegrationDesc: 'Комплексный RESTful API с документацией Swagger для бесшовной интеграции',
    
    // Use Cases section
    perfectFor: 'Идеально Для',
    
    educationalInstitutions: 'Образовательные Учреждения',
    educationalInstitutionsDesc: 'Школы, колледжи и университеты, создающие экзамены и тесты для студентов',
    
    corporateTraining: 'Корпоративное Обучение',
    corporateTrainingDesc: 'Компании, проводящие оценку сотрудников, сертификации и оценки навыков',
    
    onlineLearning: 'Онлайн-Обучение',
    onlineLearningDesc: 'Платформы электронного обучения, нуждающиеся в надежных функциях тестирования и отслеживания прогресса',
    
    certificationPrograms: 'Программы Сертификации',
    certificationProgramsDesc: 'Организации, предлагающие профессиональные сертификации и верификацию учетных данных',
    
    // Open Source section
    freeOpenSource: '100% Бесплатно и с Открытым Исходным Кодом',
    freeOpenSourceDesc: 'PublicQ полностью бесплатен для использования без лицензионных затрат. Доступен как проект с открытым исходным кодом под лицензией MIT, вы можете развернуть его на своей инфраструктуре, настроить под свои нужды и внести свой вклад в сообщество.',
    
    // CTA section
    needCustomFeatures: 'Нужны Пользовательские Функции или Поддержка?',
    needCustomFeaturesDesc: 'Хотя PublicQ бесплатен и имеет открытый исходный код, мы предлагаем профессиональные услуги по разработке пользовательских функций, помощи в развертывании, поддержке интеграции и текущему обслуживанию.',
    contactUs: 'Свяжитесь с Нами для Пользовательских Услуг',
    customizeNote: 'Мы поможем вам настроить PublicQ в соответствии с вашими потребностями',
    
    // Footer
    publicqDesc: 'Современная платформа для экзаменов и тестирования в образовании',
    quickLinks: 'Быстрые Ссылки',
    features: 'Функции',
    documentation: 'Документация',
    contact: 'Контакты',
    forCustomFeatures: 'Для пользовательских функций и профессиональной поддержки',
    iconsBy: 'Иконки на этой целевой странице предоставлены',
    copyright: 'PublicQ. Бесплатно и с открытым исходным кодом под лицензией MIT.',
  },
  
  hi: {
    // Meta
    pageTitle: 'PublicQ - शिक्षा और प्रशिक्षण के लिए निःशुल्क ओपन सोर्स मूल्यांकन मंच',
    
    // Hero section
    heroTitle: 'आधुनिक मूल्यांकन मंच',
    heroSubtitle: 'निःशुल्क और ओपन सोर्स • शैक्षिक मूल्यांकन आसानी से बनाएं, प्रबंधित करें और तैनात करें',
    oneClickDemo: 'वन क्लिक डेमो',
    learnMore: 'और जानें',
    viewOnGitHub: 'GitHub पर देखें',
    
    // Features section
    everythingYouNeed: 'वह सब कुछ जो आपको चाहिए',
    comprehensiveSolution: 'शैक्षिक और व्यावसायिक मूल्यांकन के लिए एक व्यापक समाधान',
    
    easyAssessmentCreation: 'आसान मूल्यांकन निर्माण',
    easyAssessmentDesc: 'कई प्रश्न प्रकार, फ़ाइल अटैचमेंट और अनुकूलन योग्य सेटिंग्स के साथ व्यापक मूल्यांकन बनाएं',
    
    versionControl: 'संस्करण नियंत्रण',
    versionControlDesc: 'पूर्ण संशोधन इतिहास और पिछड़ी संगतता के साथ अपने मूल्यांकन के विभिन्न संस्करणों का प्रबंधन करें',
    
    smartUserManagement: 'स्मार्ट उपयोगकर्ता प्रबंधन',
    smartUserManagementDesc: 'परीक्षा देने वाले से लेकर प्रशासक तक सात अलग-अलग भूमिकाओं के साथ भूमिका-आधारित पहुंच नियंत्रण',
    
    detailedAnalytics: 'विस्तृत विश्लेषण',
    detailedAnalyticsDesc: 'व्यापक रिपोर्ट, रियल-टाइम विश्लेषण और निर्यात क्षमताओं के साथ प्रदर्शन को ट्रैक करें',
    
    aiPoweredAssistance: 'AI-संचालित सहायता',
    aiPoweredAssistanceDesc: 'AI Monkey से मिलें - हमारा बुद्धिमान पालतू साथी! यह शरारती प्रतिभा आपको प्रश्न तैयार करने, सामग्री उत्पन्न करने और चतुर सुझाव देने में मदद करता है। यह छात्र प्रदर्शन का विश्लेषण और व्यक्तिगत सुधार योजनाएं भी बना सकता है। यह आपकी टीम में पीएचडी वाले बंदर के समान है! 🍌',
    
    realTimeExecution: 'रियल-टाइम निष्पादन',
    realTimeExecutionDesc: 'प्रगति ट्रैकिंग, स्वचालित स्कोरिंग और तत्काल परिणामों के साथ लाइव मूल्यांकन',
    
    mobileFriendly: 'मोबाइल के अनुकूल',
    mobileFriendlyDesc: 'उत्तरदायी डिज़ाइन डेस्कटॉप, टैबलेट और मोबाइल उपकरणों पर निर्बाध रूप से काम करता है',
    
    secureReliable: 'सुरक्षित और विश्वसनीय',
    secureReliableDesc: 'JWT प्रमाणीकरण, भूमिका-आधारित प्राधिकरण और व्यापक सुरक्षा सुविधाएं',
    
    communicationTools: 'संचार उपकरण',
    communicationToolsDesc: 'सिस्टम-व्यापी घोषणाएं, सूचनाएं और महत्वपूर्ण घटनाओं के लिए अनुकूलन योग्य अलर्ट',
    
    flexibleConfiguration: 'लचीला कॉन्फ़िगरेशन',
    flexibleConfigurationDesc: 'व्यवस्थापक पैनल के माध्यम से पासवर्ड नीतियों से लेकर मूल्यांकन डिफ़ॉल्ट तक सब कुछ अनुकूलित करें',
    
    easyDeployment: 'आसान तैनाती',
    easyDeploymentDesc: 'स्वचालित डेटा दृढ़ता और आसान अपडेट के साथ एकल Docker कमांड तैनाती',
    
    apiIntegration: 'API एकीकरण',
    apiIntegrationDesc: 'निर्बाध एकीकरण के लिए Swagger दस्तावेज़ीकरण के साथ व्यापक RESTful API',
    
    // Use Cases section
    perfectFor: 'इनके लिए उपयुक्त',
    
    educationalInstitutions: 'शैक्षणिक संस्थान',
    educationalInstitutionsDesc: 'स्कूल, कॉलेज और विश्वविद्यालय जो छात्रों के लिए परीक्षा और प्रश्नोत्तरी बनाते हैं',
    
    corporateTraining: 'कॉर्पोरेट प्रशिक्षण',
    corporateTrainingDesc: 'कंपनियां जो कर्मचारी मूल्यांकन, प्रमाणन और कौशल मूल्यांकन करती हैं',
    
    onlineLearning: 'ऑनलाइन सीखना',
    onlineLearningDesc: 'ई-लर्निंग प्लेटफ़ॉर्म जिन्हें मजबूत मूल्यांकन और प्रगति ट्रैकिंग सुविधाओं की आवश्यकता है',
    
    certificationPrograms: 'प्रमाणन कार्यक्रम',
    certificationProgramsDesc: 'पेशेवर प्रमाणन और क्रेडेंशियल सत्यापन प्रदान करने वाले संगठन',
    
    // Open Source section
    freeOpenSource: '100% निःशुल्क और ओपन सोर्स',
    freeOpenSourceDesc: 'PublicQ बिना किसी लाइसेंसिंग लागत के उपयोग करने के लिए पूरी तरह से मुफ़्त है। MIT लाइसेंस के तहत एक ओपन-सोर्स प्रोजेक्ट के रूप में उपलब्ध, आप इसे अपने बुनियादी ढांचे पर तैनात कर सकते हैं, इसे अपनी आवश्यकताओं के अनुसार अनुकूलित कर सकते हैं, और समुदाय में योगदान कर सकते हैं।',
    
    // CTA section
    needCustomFeatures: 'कस्टम सुविधाओं या समर्थन की आवश्यकता है?',
    needCustomFeaturesDesc: 'जबकि PublicQ निःशुल्क और ओपन सोर्स है, हम कस्टम फीचर विकास, तैनाती सहायता, एकीकरण समर्थन और चल रहे रखरखाव के लिए पेशेवर सेवाएं प्रदान करते हैं।',
    contactUs: 'कस्टम सेवाओं के लिए हमसे संपर्क करें',
    customizeNote: 'हम आपकी सटीक आवश्यकताओं के अनुरूप PublicQ को अनुकूलित करने में आपकी मदद करेंगे',
    
    // Footer
    publicqDesc: 'शिक्षा और प्रशिक्षण के लिए आधुनिक मूल्यांकन मंच',
    quickLinks: 'त्वरित लिंक',
    features: 'विशेषताएं',
    documentation: 'प्रलेखन',
    contact: 'संपर्क',
    forCustomFeatures: 'कस्टम सुविधाओं और पेशेवर समर्थन के लिए',
    iconsBy: 'इस लैंडिंग पृष्ठ पर आइकन द्वारा प्रदान किए गए',
    copyright: 'PublicQ. MIT लाइसेंस के तहत निःशुल्क और ओपन सोर्स।',
  },
  
  zh: {
    // Meta
    pageTitle: 'PublicQ - 免费开源教育培训评估考试平台',
    
    // Hero section
    heroTitle: '现代评估平台',
    heroSubtitle: '免费和开源 • 轻松创建、管理和部署教育评估',
    oneClickDemo: '一键演示',
    learnMore: '了解更多',
    viewOnGitHub: '在GitHub上查看',
    
    // Features section
    everythingYouNeed: '您需要的一切',
    comprehensiveSolution: '教育和专业评估的综合解决方案',
    
    easyAssessmentCreation: '轻松创建评估',
    easyAssessmentDesc: '使用多种问题类型、文件附件和可自定义设置构建综合评估',
    
    versionControl: '版本控制',
    versionControlDesc: '管理评估的不同版本，具有完整的修订历史记录和向后兼容性',
    
    smartUserManagement: '智能用户管理',
    smartUserManagementDesc: '基于角色的访问控制，从考生到管理员有七个不同的角色',
    
    detailedAnalytics: '详细分析',
    detailedAnalyticsDesc: '通过综合报告、实时分析和导出功能跟踪性能',
    
    aiPoweredAssistance: 'AI驱动的协助',
    aiPoweredAssistanceDesc: '认识AI Monkey - 我们聪明的宠物助手！这个淘气的天才帮助您制作问题、生成内容并提供巧妙的建议。它甚至可以分析学生表现并创建个性化的改进计划。就像在您的团队中拥有一只拥有博士学位的猴子！🍌',
    
    realTimeExecution: '实时执行',
    realTimeExecutionDesc: '实时评估，具有进度跟踪、自动评分和即时结果',
    
    mobileFriendly: '移动友好',
    mobileFriendlyDesc: '响应式设计在台式机、平板电脑和移动设备上无缝运行',
    
    secureReliable: '安全可靠',
    secureReliableDesc: 'JWT身份验证、基于角色的授权和全面的安全功能',
    
    communicationTools: '通信工具',
    communicationToolsDesc: '系统范围的公告、通知和可自定义的重要事件警报',
    
    flexibleConfiguration: '灵活配置',
    flexibleConfigurationDesc: '通过管理面板自定义从密码策略到评估默认值的所有内容',
    
    easyDeployment: '轻松部署',
    easyDeploymentDesc: '使用自动数据持久性和轻松更新的单个Docker命令部署',
    
    apiIntegration: 'API集成',
    apiIntegrationDesc: '全面的RESTful API，带有Swagger文档以实现无缝集成',
    
    // Use Cases section
    perfectFor: '完美适用于',
    
    educationalInstitutions: '教育机构',
    educationalInstitutionsDesc: '为学生创建考试和测验的学校、学院和大学',
    
    corporateTraining: '企业培训',
    corporateTrainingDesc: '进行员工评估、认证和技能评估的公司',
    
    onlineLearning: '在线学习',
    onlineLearningDesc: '需要强大的评估和进度跟踪功能的电子学习平台',
    
    certificationPrograms: '认证计划',
    certificationProgramsDesc: '提供专业认证和凭证验证的组织',
    
    // Open Source section
    freeOpenSource: '100%免费和开源',
    freeOpenSourceDesc: 'PublicQ完全免费使用，无需许可费用。作为MIT许可下的开源项目，您可以在自己的基础设施上部署它，根据需要进行自定义，并为社区做出贡献。',
    
    // CTA section
    needCustomFeatures: '需要自定义功能或支持？',
    needCustomFeaturesDesc: '虽然PublicQ是免费和开源的，但我们为自定义功能开发、部署协助、集成支持和持续维护提供专业服务。',
    contactUs: '联系我们获取自定义服务',
    customizeNote: '我们将帮助您定制PublicQ以满足您的确切需求',
    
    // Footer
    publicqDesc: '教育和培训的现代评估平台',
    quickLinks: '快速链接',
    features: '功能',
    documentation: '文档',
    contact: '联系',
    forCustomFeatures: '用于自定义功能和专业支持',
    iconsBy: '此着陆页上的图标由以下提供',
    copyright: 'PublicQ. MIT许可下免费和开源。',
  },
};
